import { ScreenerTemplateType } from "features/screener/types";

export const INITIAL_PAGE = 1;
export const KENNETH_FISHER_PRICE_TO_SALES_ID = 2;
export const DEFAULT_TYPE_PRESET: ScreenerTemplateType = 'TEMPLATE_TYPE_GURU';
export const TYPE_CUSTOM_PRESET: ScreenerTemplateType = 'TEMPLATE_TYPE_CUSTOM';